/**
 * Welcome
 */
export const SIGN_IN_DATA = 'sign_in_data'
export const NEXT_PAGE = 'next_page'
export const PREVIOUS_PAGE = 'previous_page'
export const CHOOSE_LOFT = 'choose_loft'
export const CLOSE_DIALOG = 'close_dialog'
export const RESET_CURRENT_PAGE = 'reset_current_page'


/**
 * SignIn
 */
export const LOAD_NRC_PRE_NUMBER = 'load_nrc_pre_number'
export const NRC_PRE_NUMBER = 'nrc_pre_number'
export const NRC_BODY1 = 'nrc_body1'
export const NRC_BODY2 = 'nrc_body2'
export const NRC_BODY3 = 'nrc_body3'
export const NRC_NATIONALITY = 'nrc_nationality'
export const NRC_NUMBER = 'nrc_number'
export const BOOKING_REFERENCE = 'booking_reference'
export const SIGN_IN_SUBMIT = 'submit_sign'
export const LOAD_SIGN_IN = 'load_sign_in'
export const BAD_REQUEST = 'bad_request'

/**
 * ChooseLayout
 */
export const GO_BACK_HOME = 'go_back_home'
export const NEXT_LAYOUT = 'next_layout'
export const PREVIOUS_LAYOUT = 'previous_layout'
export const CHANGE_ROOM_TYPE = 'change_room_type'
export const ROOM_TYPE = 'room_type'
export const STUDIO = 'studio'
export const ONE_BED_ROOM = 'one_bed_room'
export const TWO_BED_ROOMS = 'tow_bed_rooms'
export const THREE_BED_ROOMS = 'three_bed_rooms'

/**
 * ChooseUnit
 */
export const LOAD_TOWER = 'load_tower'
export const LOAD_FLOOR = 'load_floor'
export const GET_AVAILABlE_UNIT = 'get_available_unit'
export const FILTER_TOWER = 'filter_tower'
export const FILTER_FLOOR = 'filter_floor'
export const CHOOSED_UNIT = 'choose_unit'

/**
 * ReviewUnit
 */
export const SUBMIT_UNIT_SUCCESS = 'submit_unit_success'
export const SUBMIT_UNIT_FAILED = 'submit_unit_failed'
export const OPEN_CONFIRM_DIALOG = 'open_confirm_dialog'

/**
 * ContactUs
 */
export const CHANGE_NAME = 'change_name'
export const CHANGE_PHONE_NUMBER = 'change_phone_number'
export const CHANGE_AGE = 'change_age'
export const CHANGE_GENDER = 'change_gender'
export const CHANGE_MARITAL_SATUS = 'marital_status'
export const CHANGE_BUDGET = 'change_budget'
export const CHANGE_UNIT_TYPE = 'change_unit_type'
export const CHANGE_MESSAGE = 'change_message'
export const SUBMIT_CONTACT_SUCCESS = 'submit_contact_success'
export const SUBMIT_CONTACT_FAILED = 'submit_contact_failed'


